import { cn } from '@/lib/utils'
import Image from 'next/image'
import React from 'react'

const Logo = ({size}: {size?: 'small' | 'medium' | 'large' | 'footer'}) => {
  return (
    <Image 
        src={'/assets/logo/skillsewa_logo.jpg'}
        alt='logo'
        height={1080}
        width={1080}
        className={cn(
            'object-cover h-[4rem] w-[4rem]',
            size === 'small' && `h-[2rem] w-[2rem]`,
            size === 'medium' && `h-[5rem] w-[5rem]`,
            size === 'large' && `h-[12rem] w-[12rem]`,
            size === 'footer' && `h-[4rem] w-[4rem]`
        )}
    />
  )
}

export default Logo
